import { cn } from "@oneleet/utils";

export const CircleGdpr = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-6", className)}
    >
      <g clipPath="url(#clip0_626_52333)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#013194"
        />
        <path
          d="M8.10206 14.13H7.54406L7.49606 13.518C7.28006 13.95 6.79406 14.226 6.20606 14.226C5.00007 14.226 4.20807 13.272 4.20807 12.006C4.20807 10.74 5.00007 9.774 6.26006 9.774C7.22606 9.774 7.88606 10.344 8.09006 11.268L7.14206 11.31C7.02806 10.824 6.72206 10.542 6.24206 10.542C5.49207 10.542 5.14407 11.172 5.14407 12.006C5.14407 12.834 5.49807 13.458 6.24206 13.458C6.79406 13.458 7.10606 13.104 7.17806 12.582H6.23606V11.91H8.10206V14.13ZM10.054 9.87C11.434 9.87 12.208 10.638 12.208 12.006C12.208 13.368 11.446 14.13 10.09 14.13H8.58404V9.87H10.054ZM9.49604 13.362H10.054C10.882 13.362 11.278 12.924 11.278 12C11.278 11.076 10.882 10.638 10.054 10.638H9.49604V13.362ZM14.2726 9.87C15.2926 9.87 15.9106 10.398 15.9106 11.262C15.9106 12.126 15.2926 12.66 14.2726 12.66H13.4806V14.13H12.5686V9.87H14.2726ZM13.4806 11.892H14.2186C14.6986 11.892 14.9746 11.676 14.9746 11.262C14.9746 10.848 14.6986 10.638 14.2186 10.638H13.4806V11.892ZM18.22 9.87C19.102 9.87 19.75 10.326 19.75 11.148C19.75 11.688 19.438 12.054 18.976 12.174C19.432 12.228 19.648 12.444 19.684 12.906L19.792 14.13H18.874L18.79 13.062C18.76 12.69 18.562 12.57 18.064 12.57H17.266V14.13H16.354V9.87H18.22ZM17.266 11.808H18.088C18.556 11.808 18.814 11.598 18.814 11.226C18.814 10.848 18.562 10.638 18.088 10.638H17.266V11.808Z"
          fill="white"
        />
        <path
          d="M11.9999 1.28572L12.3509 1.8947L13.0714 2.02237L12.5678 2.52641L12.6622 3.2143L11.9999 2.91684L11.3378 3.2143L11.4321 2.52641L10.9285 2.02237L11.649 1.8947L11.9999 1.28572Z"
          fill="#FFB224"
        />
        <path
          d="M7.71424 2.57143L8.06524 3.1804L8.78566 3.30807L8.28214 3.81211L8.37646 4.49999L7.71424 4.20254L7.05208 4.49999L7.1464 3.81211L6.64282 3.30807L7.3633 3.1804L7.71424 2.57143Z"
          fill="#FFB224"
        />
        <path
          d="M4.28572 5.35715L4.63668 5.96612L5.35715 6.09377L4.85358 6.59783L4.9479 7.28573L4.28572 6.98825L3.62354 7.28573L3.71786 6.59783L3.21429 6.09377L3.93477 5.96612L4.28572 5.35715Z"
          fill="#FFB224"
        />
        <path
          d="M19.7142 5.35715L20.0652 5.96612L20.7857 6.09377L20.2821 6.59783L20.3765 7.28573L19.7142 6.98825L19.0521 7.28573L19.1464 6.59783L18.6428 6.09377L19.3633 5.96612L19.7142 5.35715Z"
          fill="#FFB224"
        />
        <path
          d="M16.2857 2.57143L16.6367 3.1804L17.3571 3.30807L16.8536 3.81211L16.9479 4.49999L16.2857 4.20254L15.6236 4.49999L15.7179 3.81211L15.2143 3.30807L15.9348 3.1804L16.2857 2.57143Z"
          fill="#FFB224"
        />
        <path
          d="M11.9999 20.7857L12.3509 21.3947L13.0714 21.5224L12.5678 22.0264L12.6622 22.7143L11.9999 22.4168L11.3378 22.7143L11.4321 22.0264L10.9285 21.5224L11.649 21.3947L11.9999 20.7857Z"
          fill="#FFB224"
        />
        <path
          d="M7.71424 19.5L8.06524 20.109L8.78566 20.2366L8.28214 20.7407L8.37646 21.4286L7.71424 21.1311L7.05208 21.4286L7.1464 20.7407L6.64282 20.2366L7.3633 20.109L7.71424 19.5Z"
          fill="#FFB224"
        />
        <path
          d="M4.28572 16.7143L4.63668 17.3233L5.35715 17.4509L4.85358 17.9549L4.9479 18.6428L4.28572 18.3454L3.62354 18.6428L3.71786 17.9549L3.21429 17.4509L3.93477 17.3233L4.28572 16.7143Z"
          fill="#FFB224"
        />
        <path
          d="M19.7142 16.7143L20.0652 17.3233L20.7857 17.4509L20.2821 17.9549L20.3765 18.6428L19.7142 18.3454L19.0521 18.6428L19.1464 17.9549L18.6428 17.4509L19.3633 17.3233L19.7142 16.7143Z"
          fill="#FFB224"
        />
        <path
          d="M16.2857 19.5L16.6367 20.109L17.3571 20.2366L16.8536 20.7407L16.9479 21.4286L16.2857 21.1311L15.6236 21.4286L15.7179 20.7407L15.2143 20.2366L15.9348 20.109L16.2857 19.5Z"
          fill="#FFB224"
        />
      </g>
      <defs>
        <clipPath id="clip0_626_52333">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
